import React from 'react'
import faceimg from "../assets/faceB.png";
import logo from '../assets/LogoMeB.png';
import styled from 'styled-components';

function About() {
  return (
    <div id='about'>
      <Desc>
        <ProfImg src={faceimg} />
        <h1>A Little About Me!</h1>
        <p>I am a Masters student at California State University San Bernardino, specializing in Computer Science. With a strong foundation in Full Stack Development, I am now eager to broaden my horizons by venturing into the exciting field of machine learning. I am committed to acquiring new skills and knowledge in order to contribute to the ever-evolving world of technology. Seeking opportunities to apply my expertise and passion, I am open to collaborations and projects that align with my professional goals. Let's connect and explore how we can create innovative solutions together.
        </p>
        <img src={logo} />
      </Desc>
    </div>
  )
}

export default About

const Desc = styled.div`
  background: #cecece;
  color: black;
  min-height: 100vh;
  padding: 0 5vw;
  align-items: center;
  padding-top: 15vh;
  img{
    height: 25vh;
  }
  p{
    @media(min-width: 768px){
      font-size: 25px;
    }
    @media(max-width: 280px){
      font-size: 5vw;
    }
  }
`

const ProfImg = styled.img`
  border: 5px solid black;
  background: black;
  border-radius: 100%;
`

